var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScrollIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 55,
    viewBox: "0 0 21 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2961",
    "data-name": "Group 2961",
    transform: "translate(-882 -900)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2960",
    "data-name": "Group 2960",
    transform: "translate(-89 135)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_4525",
    "data-name": "Path 4525",
    transform: "translate(971 765)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5,0A10.5,10.5,0,0,1,21,10.5v13a10.5,10.5,0,0,1-21,0v-13A10.5,10.5,0,0,1,10.5,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 10.5 2 C 5.813079833984375 2 2 5.813079833984375 2 10.5 L 2 23.5 C 2 28.18692016601562 5.813079833984375 32 10.5 32 C 15.18692016601562 32 19 28.18692016601562 19 23.5 L 19 10.5 C 19 5.813079833984375 15.18692016601562 2 10.5 2 M 10.5 0 C 16.29899024963379 0 21 4.701009750366211 21 10.5 L 21 23.5 C 21 29.29899024963379 16.29899024963379 34 10.5 34 C 4.701009750366211 34 0 29.29899024963379 0 23.5 L 0 10.5 C 0 4.701009750366211 4.701009750366211 0 10.5 0 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_179",
    "data-name": "Ellipse 179",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(977 771)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_180",
    "data-name": "Ellipse 180",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(980 805)",
    fill: "#fff",
    opacity: 0.71
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_181",
    "data-name": "Ellipse 181",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(980 816)",
    fill: "#fff",
    opacity: 0.71
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrollIcon);
export default __webpack_public_path__ + "static/media/scrollIcon.70a419411c189f6e7d23312784612682.svg";
export { ForwardRef as ReactComponent };